import { makeStyles } from 'tss-react/mui';

const name = 'ChainMenuItem';

export const useChainMenuItemStyles = makeStyles({ name })(theme => ({
  root: {
    ':hover': {
      color: theme.palette.text.primary,
    },
  },
  icon: {
    width: 24,
    height: 24,

    '&&': {
      color: theme.palette.text.secondary,
    },
  },
}));
